import { twMerge } from '@panwds/tailwindcss';
import React, { forwardRef, useRef, useState } from 'react';
import { mergeRefs } from '../../utils/index.js';
import { noop } from '../../utils/noop.js';
import { getBackgroundClass, getBorderClass, getCursorClass, getDisabledStyles, getRingClass } from './radio.logic.js';
/**
 * A styled radio input
 */
export const RadioInput = forwardRef((props, ref) => {
    const { isError, dataMetrics, dataTestId, addClassName, onChange, readOnly, disabled, onMouseDownCapture = noop, onMouseUpCapture = noop, onMouseOver = noop, onMouseLeave = noop, onFocus = noop, onBlur = noop, ...rest } = props;
    const internalRef = useRef();
    const inputRef = mergeRefs([ref, internalRef]);
    const [isActive, setIsActive] = useState(false);
    const [isPressed, setIsPressed] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const handleMouseDownCapture = (e) => {
        onMouseDownCapture(e);
        setIsPressed(true);
    };
    const handleMouseUpCapture = (e) => {
        onMouseUpCapture(e);
        setIsPressed(false);
    };
    const handleMouseOver = (e) => {
        onMouseOver(e);
        setIsHovered(true);
    };
    const handleMouseLeave = (e) => {
        onMouseLeave(e);
        setIsHovered(false);
    };
    const handleFocus = (e) => {
        onFocus(e);
        setIsActive(true);
    };
    const handleBlur = (e) => {
        onBlur(e);
        setIsActive(false);
        setIsPressed(false);
        setIsHovered(false);
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            internalRef.current?.click();
        }
    };
    const isChecked = rest?.checked || rest?.defaultChecked;
    return (React.createElement("input", { className: twMerge('twds-border-solid twds-form-radio twds-m-0 ', getBackgroundClass(), getCursorClass({
            disabled,
            readOnly
        }), getBorderClass({
            disabled,
            isError,
            readOnly
        }), getRingClass({ isActive, isPressed, isHovered, disabled, readOnly }), getDisabledStyles({ readOnly, isChecked }), addClassName), onMouseDownCapture: handleMouseDownCapture, onMouseUpCapture: handleMouseUpCapture, onFocus: handleFocus, onBlur: handleBlur, onMouseOver: handleMouseOver, onMouseLeave: handleMouseLeave, onKeyDown: handleKeyPress, "data-metrics": dataMetrics, "data-testid": dataTestId, onChange: onChange, disabled: disabled, readOnly: readOnly, ...rest, type: "radio", ref: inputRef }));
});
RadioInput.displayName = 'RadioInput';
//# sourceMappingURL=RadioInput.js.map